import { IExperiment, Kpi, SchemaInfor } from "../types";

export interface AutoMLState {
  experiments: Array<IExperiment>;
  tokenExperiments: string;
  folderList: Array<IExperiment>;
  loading: boolean;
  folderId: string;
  loadingCandidatesTimeSeries: boolean;
  candidatesTimeSeriesMinMax?: CandidatesTimeSeriesMinMax;
  loadingCandidatesTarget: boolean;
  candidatesTargetDistinctLength: number;
  candidatesTargetMin?: number;
  candidatesTargetMax?: number;
  models: Array<IAutoMLModel>;
  tokenModels: string;
  predictions: Array<IAutoMLPrediction>;
  tokenPredictions: string;
  autoMLDetail: IExperiment;
  evaluation: Array<IAutoMLEvaluation>;
  evalClass: Array<IAutoMLEvaluationClass>;
}

export interface AutoMLCloneConfig {
  name?: string;
  targetColumn?: SchemaInfor;
  timeSeriesColumn?: SchemaInfor;
  timeSeriesIdentifiers?: SchemaInfor[];
  featureColumns?: SchemaInfor[];
  predictionType?: SettingObject;
  primaryMetric?: Kpi;
  otherMetrics?: Kpi[];
  timeLimit?: SettingObject;
  trainMode?: SettingObject;
  splitTrainEndDate?: Date;
  splitTestEndDate?: Date;
  splitTestStartDate?: Date;
  splitTrainStartDate?: Date;
  splitType?: SettingObject;
  trainRatio?: number;
  timeSeries?: SettingObject;
  folderId?: string;
}

export interface CandidatesTimeSeriesMinMax {
  min: Date;
  max: Date;
}

export interface SettingObject {
  key: string | number;
  label: string;
}

export interface IAutoMLLeaderBoard {
  id: string;
  name: string;
  modelType: string;
  stackLevel: number;
  fitTime: number;
  predictTime: number;
  primaryMetric: string;
  valScore: number;
  testScore: number;
  percentage: boolean;
}

export interface IAutoMLModel {
  id: string;
  folderId?: string;
  isDeleted: boolean;
  businessCaseId?: string;
  compositeName?: string;
  compositeType?: string;
  lastModifiedBy?: string;
  createdBy?: string;
  lastModifiedDate?: string;
  createdDate?: string;
  datasourceId?: string;
  experimentId: string;
  name: string;
  nameReading?: string;
  modelType: string;
  stackLevel: number;
  fitTime: number;
  predictTime: number;
  valScore: any;
  testScore: any;
  featureImportance: Record<string, number>;
  modelRanking: number;
  numberSubItems: number;
  parentId?: string;
  primaryMetric: string;
  rootId?: string;
  status?: string;
  tenantId: string;
  type: string;
  predictionFile: string;
}

export interface IAutoMLPrediction {
  businessCaseId?: string;
  compositeName?: string;
  compositeType?: string;
  createdBy: string;
  createdDate: string;
  datasourceId?: string;
  description?: string;
  experimentId: string;
  explainOutput?: string;
  explainStatus?: string;
  explanationTime: number;
  fileInputName?: string;
  folderId?: string;
  id: string;
  inputBlobId: string;
  isDeleted: boolean;
  lastModifiedBy: string;
  lastModifiedDate: string;
  modelId: string;
  modelName: string;
  name: string;
  nameReading: string;
  numberRecord: number;
  numberSubItems: number;
  parentId?: string;
  predictionOutput?: string;
  predictionStatus?: string;
  predictionTime: number;
  rootId: string;
  runExplain: boolean;
  status: string;
  tenantId: string;
  type?: string;
  sheetName?: string;
  sheetIndex?: number;
  fileExtension: string;
}

export interface IAutoMLEvaluationClass {
  labelEncode: number;
  labelDecode: string;
  numbers: number;
}

export interface IAutoMLEvaluation {
  actualAvg: number;
  actualMin: number;
  actualMax: number;
  groupName: string;
  isOutlier: boolean;
  groupCount: number;
  groupOrder: number;
  predictAvg: number;
  predictMax: number;
  predictMin: number;
  percentile10?: number;
  percentile90?: number;
}

export const METRIC_LIST: { [key: string]: string } = Object.freeze({
  root_mean_squared_error: "RMSE",
  mean_absolute_error: "MAE",
  mean_absolute_percentage_error: "MAPE",
  r2: "R2",
  roc_auc: "AUC",
  accuracy: "Accuracy",
  balanced_accuracy: "Balanced Accuracy",
});

export const SMALLEST_BEST_METRICS: { [key: string]: boolean } = Object.freeze({
  root_mean_squared_error: true,
  mean_absolute_error: true,
  mean_absolute_percentage_error: true,
});

export const KPI_IN_PERCENTAGE: { [key: string]: boolean } = Object.freeze({
  r2: true,
  mean_absolute_percentage_error: true,
  accuracy: true,
  balanced_accuracy: true,
});

export const ENSEMBLE_MODEL = "WeightedEnsembleModel";
